import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { USER_GROUP_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const UserGroupService = ComposedComponent =>
  reduxFetch([
    {
      resource: USER_GROUP_RESOURCE,
      method: 'get',
      request: (organisationId, userGroupid, t) => ({
        url: apiRoutes.userGroups(organisationId, userGroupid),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getUserGroupFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UserGroupService;
